import { useShallowEnhance } from '@halo/zustand-enhance';
import { Box, Center, Flex, Spinner } from '@chakra-ui/react';
import {
  AccountType,
  isSessionCategory,
  SessionCategoryPrefix,
  useAppStore,
} from '@/store/client';
import chatPanelBodyImg from '@/assets/images/common/images/chatPanelBodyImg.jpg';
import { SessionBot, SessionGroup, SessionSingle } from '../../sessions';

export function SessionContents() {
  const { t } = useTranslation();
  const { activatedSessionId, sessionStores } = useAppStore(
    useShallowEnhance(['activatedSessionId', 'sessionStores'])
  );
  const initTrigger = useAppStore((state) => state.initTrigger);

  const sessionList = useMemo(() => {
    return Object.entries(sessionStores);
  }, [sessionStores]);

  if (!initTrigger) {
    return (
      <Center h="full" w="full">
        <Spinner size="sm" />
      </Center>
    );
  }

  if (!activatedSessionId) {
    return (
      <Box
        className="ChatPanel"
        as="section"
        display="flex"
        flexDirection="column"
        h="full"
        pl="10px"
        pr={2.5}
        py={2.5}
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          h="full"
          rounded="lg"
          background={`url(${chatPanelBodyImg})`}
          backgroundPosition="center"
          backgroundRepeat="repeat"
        >
          <Box rounded="full" bg="blackAlpha.3" px="3" py="2">
            <Box color="fg.subtle" fontSize="xs" fontWeight="medium">
              {t('chat.selectChatToStartMessaging')}
            </Box>
          </Box>
        </Flex>
      </Box>
    );
  }

  return sessionList.map(([sessionId, sessionStoreInstance]) => {
    const staticSessionStore = sessionStoreInstance.getState();
    const visible = activatedSessionId === sessionId;
    const isGroup = isSessionCategory(
      staticSessionStore?.session?.chat_id,
      SessionCategoryPrefix.Group
    );
    const isRobot =
      !isGroup && staticSessionStore?.session?.user_info?.account_type === AccountType.Robot;

    if (isRobot) {
      return (
        <SessionBot
          key={sessionId}
          visible={visible}
          sessionStoreInstance={sessionStoreInstance}
        />
      );
    }

    if (isGroup) {
      return (
        <SessionGroup
          key={sessionId}
          visible={visible}
          sessionStoreInstance={sessionStoreInstance}
        />
      );
    }

    return (
      <SessionSingle
        key={sessionId}
        visible={visible}
        sessionStoreInstance={sessionStoreInstance}
      />
    );
  });
}
